import {SignalRHub, SignalREvent} from '../../constants/dataEnum';
import {invokeAPI} from './commonBusiness';

export const getHeadBrokenTips = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_HEAD_BROKEN_TIPS));

  console.log('getHeadBrokenTips', response);

  return response;
};

export const setHeadBrokenTips = (wellPositions) => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SET_HEAD_BROKEN_TIPS, wellPositions));

  console.log('setHeadBrokenTips', response);

  return response;
};
